<template>
  <v-row>
    <v-col class="px-2 background">
      <v-dialog v-model="dialog" width="990" persistent no-click-animation scrollable>
        <v-card class="pa-0" max-height="calc(100vh - 200px)">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-bold">Información del lote {{ item?.batch_id }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items class="mr-4">
              <v-row align="center" justify="center" class="mr-n1">
                <v-btn @click="$emit('close')" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="pa-0 pb-5">
            <v-divider  />

            <!-- documents type -->
            <v-expansion-panels class="mt-5" v-model="panelDocumentType">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-5 py-3">
                  <v-row no-gutters align="center" justify="space-between">
                    <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon size="16" left color="grey-700">mdi-file</v-icon>Tipos de documentos</span>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-2">
                  <v-empty-state class="mt-n2 pb-2" v-if="!documentTypesList?.length" type="documents" id="documentos" customClass="mt-0" min-height="199" :isFree="true" title="No hay documentos" :height="199" />
                  <v-simple-table class="px-0 no-hover table-not-rounded" v-else dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left grey-700--text font-weight-medium" style="min-width: 130px;">Tipo de documento</th>
                            <th class="text-right grey-700--text font-weight-medium">Total</th>
                            <th class="text-right grey-700--text font-weight-medium">Neto</th>
                            <th class="text-right grey-700--text font-weight-medium">Iva</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(doc, i) in documentTypesList"
                            :key="i"
                          >
                            <td class="body-2">
                              <span :class="['d-inline-block text-truncate', {'font-weight-bold': doc.type === 'Total'}]" v-if="doc.type" style="max-width: 99%;">
                                <template v-if="doc.type === 'Total'">Total</template>
                                <template v-else>{{ doc.type | nameDocumentsType }}</template>
                              </span>
                              <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                            </td>
                            <td class="text-right body-2">
                              <span :class="[{'font-weight-bold': doc.type === 'Total'}]">{{ $fmt.currency(batchCurrency, doc.total) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span :class="[{'font-weight-bold': doc.type === 'Total'}]">{{ $fmt.currency(batchCurrency, doc.net) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span :class="[{'font-weight-bold': doc.type === 'Total'}]">{{ $fmt.currency(batchCurrency, doc.vat) }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- end documents type -->

            <!-- send SII -->
            <v-expansion-panels class="mt-5" v-model="panelSendAngency">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-5 py-3">
                  <v-row no-gutters align="center" justify="space-between">
                    <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon size="16" left color="grey-700">mdi-bank</v-icon>Envio al {{$t('generals.SII')}}</span>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-2">
                  <v-empty-state class="mt-n2 pb-2" v-if="!sentAgencyList?.length" type="documents" id="documentos" customClass="mt-0" :isFree="true" title="No hay documentos" :height="139" minHeight="230px" />
                  <v-simple-table class="px-0 no-hover table-not-rounded" v-else dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left grey-700--text font-weight-medium" style="width: 200px;">Tipo de documento</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 120px;">Por confirmar</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Por enviar</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Enviado</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Pendiente</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Aprobado</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Rechazado</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(doc, j) in sentAgencyList"
                            :key="j"
                          >
                            <td class="body-2">
                              <span class="d-inline-block text-truncate" v-if="doc.type" style="max-width: 99%;">
                                {{ doc.type | nameDocumentsType }}
                              </span>
                              <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.toConfirm) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.toSend) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.sent) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.pending) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.approved) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.rejected) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(doc.totalCol) }}</span>
                            </td>
                          </tr>
                          <!-- totales por fila -->
                          <tr>
                            <td class="text-left body-2">
                              <span class="font-weight-bold">Total</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.toConfirm) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.toSend) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.sent) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.pending) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.approved) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.rejected) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalSentAgencyList.total) }}</span>
                            </td>
                          </tr>
                           <!-- percentage por fila -->
                           <tr>
                            <td class="text-left body-2">
                              <span class="font-weight-bold">Porcentajes</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.toConfirm }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.toSend }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.sent }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.pending }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.approved }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.rejected }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageSentAgencyList.total }}%</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          <!-- end send SII -->

          <!-- distribution -->
          <v-expansion-panels class="mt-5" v-model="panelDistribution">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-5 py-3">
                  <v-row no-gutters align="center" justify="space-between">
                    <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon size="16" left color="grey-700">mdi-file-move</v-icon>Distribución</span>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-2">
                  <v-empty-state class="mt-n2 pb-2" v-if="!distributionList?.length" type="documents" id="documentos" customClass="mt-0" :isFree="true" title="No hay documentos" :height="139" minHeight="230px" />
                  <v-simple-table class="px-0 no-hover table-not-rounded" v-else dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left grey-700--text font-weight-medium" style="width: 200px;">Tipo de documento</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Pendiente</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Enviado</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">No enviado</th>
                            <th class="text-right grey-700--text font-weight-medium" style="width: 100px;">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(doc, k) in distributionList"
                            :key="k"
                          >
                            <td class="body-2">
                              <span class="d-inline-block text-truncate" v-if="doc.type" style="max-width: 99%;">
                                {{ doc.type | nameDocumentsType }}
                              </span>
                              <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.pending) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.sent) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span>{{ $fmt.integer(doc.notSent) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(doc.totalCol) }}</span>
                            </td>
                          </tr>
                          <!-- totales por fila -->
                          <tr>
                            <td class="text-left body-2">
                              <span class="font-weight-bold">Total</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalDistributionList.pending) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalDistributionList.sent) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalDistributionList.notSent) }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ $fmt.integer(totalDistributionList.total) }}</span>
                            </td>
                          </tr>
                           <!-- percentage por fila -->
                           <tr>
                            <td class="text-left body-2">
                              <span class="font-weight-bold">Porcentajes</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageDistributionList.pending }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageDistributionList.sent }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageDistributionList.notSent }}</span>
                            </td>
                            <td class="text-right body-2">
                              <span class="font-weight-bold">{{ percentageDistributionList.total }}%</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          <!-- end distribution -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ListViewMixin from '@/mixins/ListViewMixin'
import VEmptyState from '@/components/commons/VEmptyState'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VEmptyState
  },
  mixins: [
    ListViewMixin,
    GenericViewMixin
  ],
  data: () => ({
    loadingMetrics: false,
    panelDistribution: 1,
    panelSendAngency: 1,
    panelDocumentType: 1,
    dialog: true,
    documentTypesList: [],
    distributionList: [],
    sentAgencyList: [],
    totalDocumentTypesList: {
      total: 0,
      net: 0,
      vat: 0
    },
    totalDistributionList: {
      pending: 0,
      sent: 0,
      notSent: 0,
      total: 0
    },
    totalSentAgencyList: {
      toConfirm: 0,
      toSend: 0,
      pending: 0,
      sent: 0,
      approved: 0,
      rejected: 0,
      total: 0
    },
    percentageSentAgencyList: {
      toConfirm: 0,
      toSend: 0,
      pending: 0,
      sent: 0,
      approved: 0,
      rejected: 0,
      total: 0
    },
    percentageDistributionList: {
      pending: 0,
      sent: 0,
      notSent: 0,
      total: 0
    },
    statusPerCategory: {
      toConfirm: ['PRE'],
      toSend: ['CRE'],
      pending: ['FAI', 'MRT', 'ART'],
      sent: ['SNT'],
      approved: ['OBS', 'APR'],
      rejected: ['DUP', 'REJ']
    },
    rowTotalsByDocType: {}
  }),
  computed: {
    batchCurrency () {
      return this.item?.currency || this.$store?.state?.auth?.account?.currency
    },
    number () {
      return this.$store.state?.auth?.account?.country === 'PE' ? `${this.item.data.prefix} - ${this.item.data?.number}` : this.item.data?.number
    }
  },
  created () {
    this.loadingMetrics = true
    this.$store.dispatch('batch/LIST', {
      resource: `metrics/batches/${this.$route.params.id}/summary`,
      loader: false
    })
    .then((resp) => {
      // document types
      Object.entries(resp.data).forEach(([key, value]) => {
        if (Object.keys(value)?.length) {
          Object.entries(value).forEach(([k, v]) => {
            if (k === 'amount') {
             this.documentTypesList.push({type: key, total: v.amount_total, net: v.amount_net, vat: v.amount_vat})
            }
          })
        }
      })
      this.totalDocumentTypesList = {
        total: this.getTotal(this.documentTypesList, 'total'),
        vat: this.getTotal(this.documentTypesList, 'vat'),
        net: this.getTotal(this.documentTypesList, 'net')
      }
      this.documentTypesList.push({type: 'Total', total: this.totalDocumentTypesList.total, net: this.totalDocumentTypesList.net, vat: this.totalDocumentTypesList.vat})

      // send agency
      Object.entries(resp.data).forEach(([docTypeKey, docTypeValue]) => {
        if (docTypeValue && typeof docTypeValue === 'object' && docTypeValue.status && typeof docTypeValue.status === 'object') {
          const statusCounts = docTypeValue.status
          let totalsForCurrentDocType = {}
          for (const statusName in this.statusPerCategory) {
            totalsForCurrentDocType[statusName] = 0
          }
          Object.entries(statusCounts).forEach(([categoryCode, numericValue]) => {
            for (const statusName in this.statusPerCategory) {
              if (this.statusPerCategory[statusName].includes(categoryCode)) {
                totalsForCurrentDocType[statusName] += numericValue
                break
              }
            }
          })
          this.sentAgencyList.push({
            type: docTypeKey,
            ...totalsForCurrentDocType
          })
        }
      })

      // Compute total per document type (row-wise sum)
      this.sentAgencyList.forEach(docTypeEntry => {
        let rowTotal = 0
        for (const statusName in this.statusPerCategory) {
          if (Object.prototype.hasOwnProperty.call(docTypeEntry, statusName)) {
            rowTotal += docTypeEntry[statusName]
          }
        }
        docTypeEntry.totalCol = rowTotal
      })

      this.totalSentAgencyList = {
        toConfirm: this.getTotal(this.sentAgencyList, 'toConfirm'),
        toSend: this.getTotal(this.sentAgencyList, 'toSend'),
        pending: this.getTotal(this.sentAgencyList, 'pending'),
        sent: this.getTotal(this.sentAgencyList, 'sent'),
        approved: this.getTotal(this.sentAgencyList, 'approved'),
        rejected: this.getTotal(this.sentAgencyList, 'rejected'),
        total: this.getTotal(this.sentAgencyList, 'totalCol')
      }

      this.percentageSentAgencyList = {
        toConfirm: this.getPercentage(this.totalSentAgencyList.toConfirm, this.totalSentAgencyList.total),
        toSend: this.getPercentage(this.totalSentAgencyList.toSend, this.totalSentAgencyList.total),
        pending: this.getPercentage(this.totalSentAgencyList.pending, this.totalSentAgencyList.total),
        sent: this.getPercentage(this.totalSentAgencyList.sent, this.totalSentAgencyList.total),
        approved: this.getPercentage(this.totalSentAgencyList.approved, this.totalSentAgencyList.total),
        rejected: this.getPercentage(this.totalSentAgencyList.rejected, this.totalSentAgencyList.total),
        total: Math.round(this.getPercentage(this.totalSentAgencyList.total, this.totalSentAgencyList.total))
      }

      // distribution
      Object.entries(resp.data).forEach(([key, value]) => {
        if (Object.keys(value)?.length) {
          Object.entries(value).forEach(([k, v]) => {
            if (k === 'distribution') {
             this.distributionList.push({type: key, pending: Math.max(0, parseInt(value.count ?? 0) - (parseInt(v?.SNT ?? 0) + parseInt(v?.FAI ?? 0))), sent: parseInt(v?.SNT ?? 0), notSent: parseInt(v?.FAI ?? 0), total: 0})
            }
          })
        }
      })
      this.distributionList.forEach(docTypeEntry => {
        let rowTotal = 0
        // Sum the values of each column
        rowTotal = docTypeEntry.pending + docTypeEntry.sent + docTypeEntry.notSent
        docTypeEntry.totalCol = rowTotal
      })

      this.totalDistributionList = {
        pending: this.getTotal(this.distributionList, 'pending'),
        sent: this.getTotal(this.distributionList, 'sent'),
        notSent: this.getTotal(this.distributionList, 'notSent'),
        total: this.getTotal(this.distributionList, 'totalCol')
      }
      this.percentageDistributionList = {
        pending: this.getPercentage(this.totalDistributionList.pending, this.totalDistributionList.total),
        sent: this.getPercentage(this.totalDistributionList.sent, this.totalDistributionList.total),
        notSent: this.getPercentage(this.totalDistributionList.notSent, this.totalDistributionList.total),
        total: Math.round(this.getPercentage(this.totalDistributionList.total, this.totalDistributionList.total))
      }
    })
    .catch((error) => {
    this.$dialog.message.error(error.response.data.message)
    })
    .finally(() => {
      this.loadingMetrics = false
    })
  },
  methods: {
   getTotal (list = [], key = '') {
    return list.map(({ [key]: valorAParsear }) => parseFloat(valorAParsear) || 0)
    .reduce((sum, currentAmount) => sum + currentAmount, 0)
   },
   getPercentage (totalCol = 0, totalRow = 0) {
    return ((totalCol / totalRow) * 100).toFixed(1)
   }
  }
}
</script>